import { Utils } from '@treezor/design-system';

import { IState } from '@/store/types/search.types';
import { ITemplateGroup, ITemplateGroups } from '@/store/models/template.model';

export const TemplatesTools = {
  buildTemplateGroups: (templates: string[]): ITemplateGroups => {
    const templatesSplitted = templates.map((template) => template.split('.'));

    return templatesSplitted.reduce((accumulator, splitted) => {
      const group = splitted[0];
      const name = splitted
        .map((name) => {
          const capitalizedName = Utils.capitalize(name);
          if (!capitalizedName.includes('_')) return capitalizedName;
          return capitalizedName.replaceAll('_', ' ');
        })
        .join(' - ');

      const newGroup: IState<ITemplateGroup>[] = [
        ...(accumulator[group] || []),
        { state: { template: { fullName: splitted.join('.'), group, name } } },
      ];

      return {
        ...accumulator,
        [group]: newGroup,
      };
    }, {});
  },
};
